import React, { useState, useEffect } from "react";
import api from "../services/api";
import DOMPurify from "dompurify";
export default function Terms(props) {
  // null = loading, false = API failed (render hardcoded fallback)
  const [pageContent, setPageContent] = useState(null);
  const getContentPage = async () => {
    try {
      var response = await api.get("/get-content-page", {
        page_uid: "terms_and_conditions",
      });
      setPageContent(response.status == 200 ? response.data : false);
    } catch (e) {
      setPageContent(false);
    }
  };

  useEffect(() => {
    getContentPage();
  }, []);
  const renderHTML = (rawHTML: string) =>
    React.createElement("div", {
      dangerouslySetInnerHTML: { __html: DOMPurify.sanitize(rawHTML) },
    });

  // While loading, render an empty shell so the hardcoded fallback never flashes.
  if (pageContent === null) {
    return (
      <div class="container-xxl">
        <section className="contentPage"></section>
      </div>
    );
  }

  // BO-managed content (incl. per-country variants); hardcoded text below is the fallback.
  if (pageContent && pageContent.content_data) {
    return (
      <div class="container-xxl">
        <section className="contentPage">
          <div className="pageTitle">{pageContent.content_data.page_title}</div>
          <div className="paragraph">
            {renderHTML(pageContent.content_data.content)}
          </div>
        </section>
      </div>
    );
  }

  return (
    <>
      <div class="container-xxl">
        <section className="contentPage">
          {/* <div className="pageTitle">
            {pageContent && pageContent.content_data.page_title}
          </div>
          <div className="paragraph">
            {pageContent && renderHTML(pageContent.content_data.content)}
          </div> */}

          <div className="pageTitle">Terms and Conditions</div>
          <div className="paragraph">
            <p>
              <strong>Last updated:</strong> March 03, 2025
            </p>

            <h2>1. Introduction</h2>
            <p>
              These terms and conditions and the documents referred to below
              (the "Terms") apply to the use of the current website{" "}
              <a href="http://pcplay365.com">pcplay365.com</a> (the "Website") and
              its related or connected services (collectively, the "Service").
            </p>
            <p>
              You should carefully review these Terms as they contain important
              information concerning your rights and obligations concerning the
              use of the Website and form a binding legal agreement between you
              - our customer (the "Customer"), and us. By using this Website
              and/or accessing the Service, you, whether you are a guest or a
              registered user with an account (“Account”), agree to be bound by
              these Terms, together with any amendments, which may be published
              from time to time. If you do not accept these Terms, you should
              refrain from accessing the Service and using the Website.
            </p>
            <p>
              The Service is owned by ChapChap Technologies Ltd, a limited
              liability company registered in Island of Anjouan, Comoros with
              company registration number 15788, with registered address at
              Hamchako Mutsamudu, The Autonomous Island of Anjouan, Union of
              Comoros.
            </p>
            <p>
              PC Play365 is licensed in the State of Anjouan under the Computer
              Gaming Licensing Act 007 of 2005 under License No
              ALSI-202409025-FI2.
            </p>

            <h2>2. General Terms</h2>
            <p>
              We reserve the right to revise and amend the Terms (including any
              documents referred to and linked to below) at any time. You should
              visit this page periodically to review the Terms and Conditions.
              Amendments will be binding and effective immediately upon
              publication on this Website. If you object to any such changes,
              you must immediately stop using the Service. Your continued use of
              the Website following such publication will indicate your
              agreement to be bound by the Terms as amended. Any bets not
              settled prior to the changed Terms taking effect will be subject
              to the pre-existing Terms.
            </p>

            <h2>3. Your Obligations</h2>
            <p>
              You acknowledge that at all times when accessing the Website and
              using the Service:
            </p>
            <ol>
              <li>
                You are over 18, or the legal age at which gambling, or gaming
                activities are allowed under the law or jurisdiction that
                applies to you. We reserve the right to request proof of age
                documents from you at any time.
              </li>
              <li>
                You are of legal capacity and can enter into a binding legal
                agreement with us. You must not access the Website or utilize
                the Service if you are not of legal capacity.
              </li>
              <li>
                You are a resident in a jurisdiction that allows gambling. You
                are not a resident of any country in which access to online
                gambling to its residents or to any person within such country
                is prohibited. It is your sole responsibility to ensure that
                your use of the service is legal.
              </li>
              <li>
                You may not use a VPN, proxy or similar services or devices that
                mask or manipulate the identification of your real location.
              </li>
              <li>
                You are the authorized user of the payment method you use.
              </li>
              <li>
                You must make all payments to us in good faith and not attempt
                to reverse a payment made or take any action which will cause
                such payment to be reversed by a third party.
              </li>
              <li>
                When placing bets you may lose some or all of your money
                deposited to the Service in accordance with these Terms and you
                will be fully responsible for that loss.
              </li>
              <li>
                When placing bets you must not use any information obtained in
                breach of any legislation in force in the country in which you
                were when the bet was placed.
              </li>
              <li>
                You are not acting on behalf of another party or for any
                commercial purposes, but solely on your own behalf as a private
                individual in a personal capacity.
              </li>
              <li>
                You must not either attempt to manipulate any market or element
                within the Service in bad faith nor in a manner that adversely
                affects the integrity of the Service or us.
              </li>
              <li>
                You must generally act in good faith in relation to us of the
                Service at all times and for all bets made using the Service.
              </li>
              <li>
                You, or, if applicable, your employees, employers, agents, or
                family members, are not registered as an Affiliate in our
                Affiliate program.
              </li>
            </ol>

            <h2>4. Restricted use</h2>
            <p>You must not use the Service:</p>
            <ol>
              <li>
                If you are under the age of 18 years (or below the age of
                majority as stipulated in the laws of the jurisdiction
                applicable to you) or if you are not legally able to enter into
                a binding legal agreement with us or you acting as an agent for,
                or otherwise on behalf, of a person under 18 years (or below the
                age of majority as stipulated in the laws of the jurisdiction
                applicable to you);
              </li>
              <li>
                If you reside in a country in which access to online gambling to
                its residents or to any person within such country is
                prohibited.
              </li>
              <li>
                If you are a resident of one of the following countries, or
                accessing the Website from one of the following countries:
                <ul>
                  <li>Austria</li>
                  <li>France and its territories</li>
                  <li>Germany</li>
                  <li>Netherlands and its territories</li>
                  <li>Spain</li>
                  <li>Union of Comoros</li>
                  <li>United Kingdom</li>
                  <li>USA and its territories</li>
                  <li>All FATF Blacklisted countries,</li>
                  <li>
                    Any other jurisdictions deemed prohibited by Anjouan
                    Offshore Financial Authority.
                  </li>
                </ul>
              </li>
              <li>
                To collect nicknames, e-mail addresses and/or other information
                of other Customers by any means (for example, by sending spam,
                other types of unsolicited emails or the unauthorised framing
                of, or linking to, the Service);
              </li>
              <li>
                to disrupt or unduly affect or influence the activities of other
                Customers or the operation of the Service generally;
              </li>
              <li>
                to promote unsolicited commercial advertisements, affiliate
                links, and other forms of solicitation which may be removed from
                the Service without notice;
              </li>
              <li>
                in any way which, in our reasonable opinion, could be considered
                as an attempt to: (i) cheat the Service or another Customer
                using the Service; or (ii) collude with any other Customer using
                the Service in order to obtain a dishonest advantage;
              </li>
              <li>
                to scrape our odds or violate any of our Intellectual Property
                Rights; or
              </li>
              <li>for any unlawful activity whatsoever.</li>
            </ol>
            <p>
              You cannot sell or transfer your account to third parties, nor can
              you acquire a player account from a third party.
            </p>
            <p>
              You may not, in any manner, transfer funds between player
              accounts.
            </p>
            <p>
              We may immediately terminate your Account upon written notice to
              you if you use the Service for unauthorised purposes. We may also
              take legal action against you for doing so in certain
              circumstances.
            </p>
            <p>
              Employees of Company, its licensees, distributors, wholesalers,
              subsidiaries, advertising, promotional or other agencies, media
              partners, contractors, retailers and members of the immediate
              families of each are NOT allowed to use the Service for real money
              without prior consent from the Company Director or CEO. Should
              such activity be discovered, the account(s) will be immediately
              terminated and all bonuses/winnings will be forfeited.
            </p>

            <h2>5. Registration</h2>
            <p>You agree that at all times when using the Service:</p>
            <ol>
              <li>
                We reserve the right to refuse to accept a registration
                application from any applicant at our sole discretion and
                without any obligation to communicate a specific reason.
              </li>
              <li>
                Before using the Service, you must personally complete the
                registration form and read and accept these Terms. In order to
                start betting on the Service or withdraw your winnings, we may
                require you to become a verified Customer which includes passing
                certain checks. You may be required to provide a valid proof of
                identification and any other document as it may be deemed
                necessary. This includes but is not limited to, a picture ID
                (copy of passport, driver's licence or national ID card) and a
                recent utility bill listing your name and address as proof of
                residence. We reserve the right to suspend wagering or restrict
                Account options on any Account until the required information is
                received. This procedure is done in accordance with the
                applicable gaming regulation and the anti-money laundering legal
                requirements. Additionally, you will need to fund your Service
                Account using the payment methods set out on the payment section
                of our Website.
              </li>
              <li>
                You have to provide accurate contact information, inclusive of a
                valid email address (“Registered Email Address”), and update
                such information in the future to keep it accurate. It is your
                responsibility to keep your contact details up to date on your
                Account. Failure to do so may result in you failing to receive
                important Account related notifications and information from us,
                including changes we make to these Terms. We identify and
                communicate with our Customers via their Registered Email
                Address. It is the responsibility of the Customer to maintain an
                active and unique email account, to provide us with the correct
                email address and to advise Company of any changes in their
                email address. Each Customer is wholly responsible for
                maintaining the security of his Registered Email Address to
                prevent the use of his Registered Email Address by any third
                party. Company shall not be responsible for any damages or
                losses deemed or alleged to have resulted from communications
                between Company and the Customer using the Registered Email
                Address. Any Customer not having an email address reachable by
                Company will have his Account suspended until such an address is
                provided to us. We will immediately suspend your Account upon
                written notice to you to this effect if you intentionally
                provide false or inaccurate personal information. We may also
                take legal action against you for doing so in certain
                circumstances and/or contact the relevant authorities who may
                also take action against you.
              </li>
              <li>
                You are only allowed to register one Account with the Service.
                Accounts are subject to immediate closure if it is found that
                you have multiple Accounts registered with us. This includes the
                use of representatives, relatives, associates, affiliates,
                related parties, connected persons and/or third parties
                operating on your behalf.
              </li>
              <li>
                In order to ensure your financial worthiness and to confirm your
                identity, we may ask you to provide us with additional personal
                information, such as your name and surname, or use any
                third-party information providers we consider necessary. Should
                any additional personal information be obtained via third-party
                sources, we will inform you about the data obtained.
              </li>
              <li>
                You must keep your password for the Service confidential.
                Provided that the Account information requested has been
                correctly supplied, we are entitled to assume that bets,
                deposits and withdrawals have been made by you. We advise you to
                change your password on a regular basis and never disclose it to
                any third party. It is your responsibility to protect your
                password and any failure to do so shall be at your sole risk and
                expense. You may log out of the Service at the end of each
                session. If you believe any of your Account information is being
                misused by a third party, or your Account has been hacked into,
                or your password has been discovered by a third party, you must
                notify us immediately. You must notify us if your Registered
                Email Address has been hacked into, we may, however, require you
                to provide additional information/ documentation so that we can
                verify your identity. We will immediately suspend your Account
                once we are aware of such an incident. In the meantime you are
                responsible for all activity on your Account including third
                party access, regardless of whether or not their access was
                authorised by you.
              </li>
              <li>
                You must not at any time transmit any content or other
                information on the Service to another Customer or any other
                party by way of a screen capture (or other similar method), nor
                display any such information or content in a frame or in any
                other manner that is different from how it would appear if such
                Customer or third party had typed the URL for the Service into
                the browser line.
              </li>
              <li>
                When registering, you will receive possibility to use all
                currencies available on the website. Those will be the
                currencies of your deposits, withdrawals and bets placed and
                matched into the Service as set out in these Terms. Some payment
                methods do not process in all currencies. In such cases a
                processing currency will be displayed, along with a conversion
                calculator available on the page.
              </li>
              <li>
                We are under no obligation to open an Account for you and our
                website sign-up page is merely an invitation to treat. It is
                entirely within our sole discretion whether or not to proceed
                with the opening of an Account for you and, should we refuse to
                open an Account for you, we are under no obligation to provide
                you with a reason for the refusal.
              </li>
              <li>
                Upon receipt of your application, we may be in touch to request
                further information and/ or documentation from you in order for
                us to comply with our regulatory and legal obligations.
              </li>
            </ol>

            <h2>6. Your Account</h2>
            <ol>
              <li>
                Accounts could use several currencies, in this case all Account
                balances and transactions appear in the currency used for the
                transaction.
              </li>
              <li>We do not give credit for the use of the Service.</li>
              <li>
                We may close or suspend an Account if you are not or we
                reasonably believe that you are not complying with these Terms,
                or to ensure the integrity or fairness of the Service or if we
                have other reasonable grounds to do so. We may not always be
                able to give you prior notice. If we close or suspend your
                Account due to you not complying with these Terms, we may cancel
                and/or void any of your bets and withhold any money in your
                account (including the deposit).
              </li>
              <li>
                We reserve the right to close or suspend any Account without
                prior notice and return all funds. Contractual obligations
                already matured will however be honoured.
              </li>
              <li>
                We reserve the right to refuse, restrict, cancel or limit any
                wager at any time for whatever reason, including any bet
                perceived to be placed in a fraudulent manner in order to
                circumvent our betting limits and/ or our system regulations.
              </li>
              <li>
                If any amount is mistakenly credited to your Account it remains
                our property and when we become aware of any such mistake, we
                shall notify you and the amount will be withdrawn from your
                Account.
              </li>
              <li>
                If, for any reason, your Account goes overdrawn, you shall be in
                debt to us for the amount overdrawn.
              </li>
              <li>
                You must inform us as soon as you become aware of any errors
                with respect to your Account.
              </li>
              <li>
                Please remember that betting is purely for entertainment and
                pleasure and you should stop as soon as it stops being fun.
                Absolutely do not bet anything you can’t afford to lose. If you
                feel that you may have lost control of your gambling, we offer a
                self-exclusion option. Just send a message to our Customer
                Support Department using your Registered Email Address that you
                wish to SELF-EXCLUDE and this request will take effect within 24
                hours from the moment of its receipt. In this case your account
                will be disabled until your further notice, and you won’t be
                able to login to it.
              </li>
              <li>
                You cannot transfer, sell, or pledge Your Account to another
                person. This prohibition includes the transfer of any assets of
                value of any kind, including but not limited to ownership of
                accounts, winnings, deposits, bets, rights and/or claims in
                connection with these assets, legal, commercial or otherwise.
                The prohibition on said transfers also includes however is not
                limited to the encumbrance, pledging, assigning, usufruct,
                trading, brokering, hypothecation and/or gifting in cooperation
                with a fiduciary or any other third party, company, natural or
                legal individual, foundation and/or association in any way shape
                or form.
              </li>
              <li>
                Should you wish to close your account with us, please send an
                email from your Registered Email Address to our Customer Support
                Department via the links on the Website.
              </li>
            </ol>

            <h2>7. Deposit of Funds</h2>
            <ol>
              <li>
                All deposits should be made from an account or payment system or
                credit card that is registered in your own name, and any
                deposits made in any other currency will be converted using the
                daily exchange rate obtained from oanda.com, or at our own
                bank's or our payment processor’s prevailing rate of exchange
                following which your Account will be deposited accordingly. Note
                that some payment systems may apply additional currency exchange
                fees which will be deducted from the sum of your deposit.
              </li>
              <li>
                Fees and charges may apply to customer deposits and withdrawals,
                which can be found on the Website. In most cases we absorb
                transaction fees for deposits to your pcplay365.com Account. You
                are responsible for your own bank charges that you may incur due
                to depositing funds with us.
              </li>
              <li>
                Company is not a financial institution and uses a third party
                electronic payment processors to process credit and debit card
                deposits; they are not processed directly by us. If you deposit
                funds by either a credit card or a debit card, your Account will
                only be credited if we receive an approval and authorisation
                code from the payment issuing institution. If your card issuer
                gives no such authorisation, your Account will not be credited
                with those funds.
              </li>
              <li>
                You agree to fully pay any and all payments and charges due to
                us or to payment providers in connection with your use of the
                Service. You further agree not to make any charge-backs or
                renounce or cancel or otherwise reverse any of your deposits,
                and in any such event you will refund and compensate us for such
                unpaid deposits including any expenses incurred by us in the
                process of collecting your deposit, and you agree that any
                winnings from wagers utilising those charged back funds will be
                forfeited. You acknowledge and agree that your player account is
                not a bank account and is therefore not guaranteed, insured or
                otherwise protected by any deposit or banking insurance system
                or by any other similar insurance system of any other
                jurisdiction, including but not limited to your local
                jurisdiction. Furthermore, the player account does not bear
                interest on any of the funds held in it.
              </li>
              <li>
                If you decide to accept any of our promotional or bonus offer by
                entering a bonus code during deposit, you agree to the Terms of
                Bonuses and terms of each specific bonus.
              </li>
              <li>
                Funds originating from criminal and/or illegal and/or
                unauthorized activities must not be deposited with us.
              </li>
              <li>
                If you deposit using your credit card, it is recommended that
                you retain a copy of Transaction Records and a copy of these
                Terms.
              </li>
              <li>
                Internet Gambling may be illegal in the jurisdiction in which
                you are located; if so, you are not authorized to use your
                payment card to deposit on this site. It is your responsibility
                to know the laws concerning online gambling in your country of
                domicile.
              </li>
            </ol>

            <h2>8. Withdrawal of Funds</h2>
            <ol>
              <li>
                You may withdraw any unutilized and cleared funds held in your
                player account by submitting a withdrawal request in accordance
                with our withdrawal conditions. The minimum withdrawal amount
                per transaction is € 10 (or equivalent in other currency) with
                the exception of an account closure in which case you may
                withdraw the full balance.
              </li>
              <li>
                There are no withdrawal commissions if you roll over (wager) the
                deposit at least 1 time. Otherwise we are entitled to deduct a
                8% fee with minimum sum of 4 euro (or equivalent in your account
                currency) in order to combat money laundering.
              </li>
              <li>
                We reserve the right to request photo ID, address confirmation
                or perform additional verification procedures (request your
                selfie, arrange a verification call etc.) for the purpose of
                identity verification prior to granting any withdrawals from
                your Account. We also reserve our rights to perform identity
                verification at any time during the lifetime of your
                relationship with us.
              </li>
              <li>
                All withdrawals must be made to the original debit, credit card,
                bank account, method of payment used to make the payment to your
                Account. We may, and always at our own discretion, allow you to
                withdraw to a payment method from which your original deposit
                did not originate. This will always be subject to additional
                security checks.
              </li>
              <li>
                Should you wish to withdraw funds but your account is either
                inaccessible, dormant, locked or closed, please contact our
                Customer Service Department.
              </li>
              <li>
                In cases when your balance is at least 10 times larger than the
                total sum of your deposits, you will be limited to € 5,000 (or
                currency equivalent) for withdrawal per month. In other cases
                the maximum withdrawal amount per month is € 10,000.
              </li>
              <li>
                Please note that we cannot guarantee successful processing of
                withdrawals or refunds in the event if you breach the Restricted
                use policy stated in Clauses 3.3 and 4.
              </li>
            </ol>

            <h2>9. Payment Transactions and Processors</h2>
            <ol>
              <li>
                You are fully responsible for paying all monies owed to us. You
                must make all payments to us in good faith and not attempt to
                reverse a payment made or take any action which will cause such
                payment to be reversed by a third party in order to avoid a
                liability legitimately incurred. You will reimburse us for any
                charge-backs, denial or reversal of payment you make and any
                loss suffered by us as a consequence thereof. We reserve the
                right to also impose an administration fee of €50, or currency
                equivalent per charge-back, denial or reversal of payment you
                make.
              </li>
              <li>
                We reserve the right to use third party electronic payment
                processors and or merchant banks to process payments made by you
                and you agree to be bound by their terms and conditions
                providing they are made aware to you and those terms do not
                conflict with these Terms.
              </li>
              <li>
                All transactions made on our site might be checked to prevent
                money laundering or terrorism financing activity. Suspicious
                transactions will be reported to the relevant authority.
              </li>
            </ol>

            <h2>10. Errors</h2>
            <ol>
              <li>
                In the event of an error or malfunction of our system or
                processes, all bets are rendered void. You are under an
                obligation to inform us immediately as soon as you become aware
                of any error with the Service. In the event of communication or
                system errors or bugs or viruses occurring in connection with
                the Service and/or payments made to you as a result of a defect
                or error in the Service, we will not be liable to you or to any
                third party for any direct or indirect costs, expenses, losses
                or claims arising or resulting from such errors, and we reserve
                the right to void all games/bets in question and take any other
                action to correct such errors.
              </li>
              <li>
                We make every effort to ensure that we do not make errors in
                posting bookmaker lines. However, if as a result of human error
                or system problems a bet is accepted at an odd that is:
                materially different from those available in the general market
                at the time the bet was made; or clearly incorrect given the
                chance of the event occurring at the time the bet was made then
                we reserve the right to cancel or void that wager, or to cancel
                or void a wager made after an event has started.
              </li>
              <li>
                We have the right to recover from you any amount overpaid and to
                adjust your Account to rectify any mistake. An example of such a
                mistake might be where a price is incorrect or where we enter a
                result of an event incorrectly. If there are insufficient funds
                in your Account, we may demand that you pay us the relevant
                outstanding amount relating to any erroneous bets or wagers.
                Accordingly, we reserve the right to cancel, reduce or delete
                any pending plays, whether placed with funds resulting from the
                error or not.
              </li>
            </ol>

            <h2>
              11. Rules of Play, refunds and cancellations (applicable to Sports
              Betting if available)
            </h2>
            <ol>
              <li>
                The winner of an event will be determined on the date of the
                event's settlement, and we will not recognize protested or
                overturned decisions for wagering purposes.
              </li>
              <li>
                All results posted shall be final after 72 hours and no queries
                will be entertained after that period of time. Within 72 hours
                after results are posted, we will only reset/correct the results
                due to human error, system error or mistakes made by the
                referring results source.
              </li>
              <li>
                If a match result is overturned for any reason by the governing
                body of the match within the payout period then all money will
                be refunded.
              </li>
              <li>
                If a draw occurs in a game where a draw option is offered all
                stakes on a team win or lose will be lost. If a draw option is
                not offered then everyone receives a refund in the outcome of a
                draw on the match. And if a draw option has not been made
                available, then extra time will count, if played.
              </li>
              <li>
                If a result cannot be validated by us, for instance if the feed
                broadcasting the event is interrupted (and cannot be verified by
                another source) then at our election, the wagers on that event
                will be deemed invalid and wagers refunded.
              </li>
              <li>
                Minimum and maximum wager amounts on all events will be
                determined by us and are subject to change without prior written
                notice. We also reserve the right to adjust limits on individual
                Accounts as well.
              </li>
              <li>
                Customers are solely responsible for their own Account
                transactions. Once a transaction is complete, it cannot be
                changed. We do not take responsibility for missing or duplicate
                wagers made by the Customer and will not entertain discrepancy
                requests because a play is missing or duplicated. Customers may
                review their transactions in the My Account section of the site
                after each session to ensure all requested wagers were accepted.
              </li>
              <li>
                A matchup will have action as long as the two teams are correct,
                and regardless of the League header in which it is placed on our
                Website.
              </li>
              <li>
                The start dates and times displayed on the Website for eSport
                matches are an indication only and are not guaranteed to be
                correct. If a match is suspended or postponed, and not resumed
                within 72 hours from the actual scheduled start time, the match
                will have no action and wagers will be refunded. The exception
                being any wager on whether a team/player advances in a
                tournament, or wins the tournament, will have action regardless
                of a suspended or postponed match.
              </li>
              <li>
                If an event is posted by us with an incorrect date, all wagers
                have action based on the date announced by the governing body.
              </li>
              <li>
                If a team is using stand-ins, the result is still valid as it
                was the team's choice to use the stand-ins.
              </li>
              <li>
                Company reserves the right to remove events, markets and any
                other products from the Website.
              </li>
            </ol>

            <h2>12. Communications and Notices</h2>
            <ol>
              <li>
                All communications and notices to be given under these Terms by
                you to us shall be sent using a Customer Support form on the
                Website.
              </li>
              <li>
                All communications and notices to be given under these Terms by
                us to you shall, unless otherwise specified in these Terms, be
                either posted on the Website and/or sent to the Registered Email
                Address we hold on our system for the relevant Customer. The
                method of such communication shall be in our sole and exclusive
                discretion.
              </li>
              <li>
                All communications and notices to be given under these Terms by
                either you or us shall be in writing in the English language and
                must be given to and from the Registered Email Address in your
                Account.
              </li>
              <li>
                From time to time, we may contact you by email for the purpose
                of offering you information about betting, unique promotional
                offerings, and other information from pcplay365.com. You agree to
                receive such emails when you agree to these Terms when
                registering at the Website. You can choose to opt out of
                receiving such promotional offerings from us at any time by
                submitting a request to the Customer Support.
              </li>
            </ol>

            <h2>13. Matters Beyond Our Control</h2>
            <p>
              We cannot be held liable for any failure or delay in providing the
              Service due to an event of Force Majeure which could reasonably be
              considered to be outside our control despite our execution of
              reasonable preventative measures such as: an act of God; trade or
              labour dispute; power cut; act, failure or omission of any
              government or authority; obstruction or failure of
              telecommunication services; or any other delay or failure caused
              by a third party, and we will not be liable for any resulting loss
              or damage that you may suffer. In such an event, we reserve the
              right to cancel or suspend the Service without incurring any
              liability.
            </p>

            <h2>14. Liability</h2>
            <ol>
              <li>
                TO THE EXTENT PERMITTED BY APPLICABLE LAW, WE WILL NOT
                COMPENSATE YOU FOR ANY REASONABLY FORESEEABLE LOSS OR DAMAGE
                (EITHER DIRECT OR INDIRECT) YOU MAY SUFFER IF WE FAIL TO CARRY
                OUT OUR OBLIGATIONS UNDER THESE TERMS UNLESS WE BREACH ANY
                DUTIES IMPOSED ON US BY LAW (INCLUDING IF WE CAUSE DEATH OR
                PERSONAL INJURY BY OUR NEGLIGENCE) IN WHICH CASE WE SHALL NOT BE
                LIABLE TO YOU IF THAT FAILURE IS ATTRIBUTED TO: (I) YOUR OWN
                FAULT; (II) A THIRD PARTY UNCONNECTED WITH OUR PERFORMANCE OF
                THESE TERMS (FOR INSTANCE PROBLEMS DUE TO COMMUNICATIONS NETWORK
                PERFORMANCE, CONGESTION, AND CONNECTIVITY OR THE PERFORMANCE OF
                YOUR COMPUTER EQUIPMENT); OR (III) ANY OTHER EVENTS WHICH
                NEITHER WE NOR OUR SUPPLIERS COULD HAVE FORESEEN OR FORESTALLED
                EVEN IF WE OR THEY HAD TAKEN REASONABLE CARE. AS THIS SERVICE IS
                FOR CONSUMER USE ONLY WE WILL NOT BE LIABLE FOR ANY BUSINESS
                LOSSES OF ANY KIND.
              </li>
              <li>
                IN THE EVENT THAT WE ARE HELD LIABLE FOR ANY EVENT UNDER THESE
                TERMS, OUR TOTAL AGGREGATE LIABILITY TO YOU UNDER OR IN
                CONNECTION WITH THESE TERMS SHALL NOT EXCEED (A) THE VALUE OF
                THE BETS AND OR WAGERS YOU PLACED VIA YOUR ACCOUNT IN RESPECT OF
                THE RELEVANT BET/WAGER OR PRODUCT THAT GAVE RISE TO THE RELEVANT
                LIABILITY, OR (B) EUR €500 IN AGGREGATE, WHICHEVER IS LOWER.
              </li>
              <li>
                WE STRONGLY RECOMMEND THAT YOU (I) TAKE CARE TO VERIFY THE
                SUITABILITY AND COMPATIBILITY OF THE SERVICE WITH YOUR OWN
                COMPUTER EQUIPMENT PRIOR TO USE; AND (II) TAKE REASONABLE
                PRECAUTIONS TO PROTECT YOURSELF AGAINST HARMFUL PROGRAMS OR
                DEVICES INCLUDING THROUGH INSTALLATION OF ANTI-VIRUS SOFTWARE.
              </li>
            </ol>

            <h2>15. Gambling By Those Under Age</h2>
            <ol>
              <li>
                If we suspect that you are or receive notification that you are
                currently under 18 years or were under 18 years (or below the
                age of majority as stipulated in the laws of the jurisdiction
                applicable to you) when you placed any bets through the Service
                your Account will be suspended (locked) to prevent you placing
                any further bets or making any withdrawals from your Account. We
                will then investigate the matter, including whether you have
                been betting as an agent for, or otherwise on behalf, of a
                person under 18 years (or below the age of majority as
                stipulated in the laws of the jurisdiction applicable to you).
                If having found that you: (a) are currently; (b) were under 18
                years or below the majority age which applies to you at the
                relevant time; or (c) have been betting as an agent for or at
                the behest of a person under 18 years or below the majority age
                which applies:
                <ul>
                  <li>
                    All winnings currently or due to be credited to your Account
                    will be retained;
                  </li>
                  <li>
                    All winnings gained from betting through the Service whilst
                    under age must be paid to us
                  </li>
                  <li>
                    On demand (if you fail to comply with this provision we will
                    seek to recover all costs associated with recovery of such
                    sums); and/or
                  </li>
                  <li>
                    Any monies deposited in your Account which are not winnings
                    will be returned to you OR retained until you turn 18 years
                    old at our sole discretion. We reserve the right to deduct
                    payment transaction fees from the amount to return,
                    including transaction fees for deposits to your pcplay365.com
                    account which we covered.
                  </li>
                </ul>
              </li>
              <li>
                This condition also applies to you if you are over the age of 18
                years but you are placing your bets within a jurisdiction which
                specifies a higher age than 18 years for legal betting and you
                are below that legal minimum age in that jurisdiction.
              </li>
              <li>
                In the event we suspect you are in breach of the provisions of
                this Clause or are attempting to rely on them for a fraudulent
                purpose, we reserve the right to take any action necessary in
                order to investigate the matter, including informing the
                relevant law enforcement agencies.
              </li>
            </ol>

            <h2>16. Fraud</h2>
            <p>
              We will seek criminal and contractual sanctions against any
              Customer involved in fraud, dishonesty or criminal acts. We will
              withhold payment to any Customer where any of these are suspected.
              The Customer shall indemnify and shall be liable to pay to us on
              demand all costs, charges or losses sustained or incurred by us
              (including any direct, indirect or consequential losses, loss of
              profit, loss of business and loss of reputation) arising directly
              or indirectly from the Customer’s fraud, dishonesty or criminal
              act.
            </p>

            <h2>17. Intellectual Property</h2>
            <ol>
              <li>
                Any unauthorised use of our name and logo may result in legal
                action being taken against you.
              </li>
              <li>
                As between us and you, we are the sole owners of the rights in
                and to the Service, our technology, software and business
                systems (the "Systems") as well as our odds. you must not use
                your personal profile for your own commercial gain (such as
                selling your status update to an advertiser); and when selecting
                a nickname for your Account we reserve the right to remove or
                reclaim it if we believe it appropriate.
              </li>
              <li>
                You may not use our URL, trademarks, trade names and/or trade
                dress, logos ("Marks") and/or our odds in connection with any
                product or service that is not ours, that in any manner is
                likely to cause confusion among Customers or in the public or
                that in any manner disparages us.
              </li>
              <li>
                Except as expressly provided in these Terms, we and our
                licensors do not grant you any express or implied rights,
                license, title or interest in or to the Systems or the Marks and
                all such rights, license, title and interest specifically
                retained by us and our licensors. You agree not to use any
                automatic or manual device to monitor or copy web pages or
                content within the Service. Any unauthorized use or reproduction
                may result in legal action being taken against you.
              </li>
            </ol>

            <h2>18. Your License</h2>
            <ol>
              <li>
                Subject to these Terms and your compliance with them, we grant
                to you a non-exclusive, limited, non transferable and non
                sub-licensable license to access and use the Service for your
                personal non-commercial purposes only. Our license to you
                terminates if our agreement with you under these Terms ends.
              </li>
              <li>
                Save in respect of your own content, you may not under any
                circumstances modify, publish, transmit, transfer, sell,
                reproduce, upload, post, distribute, perform, display, create
                derivative works from, or in any other manner exploit, the
                Service and/or any of the content thereon or the software
                contained therein, except as we expressly permit in these Terms
                or otherwise on the Website. No information or content on the
                Service or made available to you in connection with the Service
                may be modified or altered, merged with other data or published
                in any form including for example screen or database scraping
                and any other activity intended to collect, store, reorganise or
                manipulate such information or content.
              </li>
              <li>
                Any non-compliance by you with this Clause may also be a
                violation of our or third parties' intellectual property and
                other proprietary rights which may subject you to civil
                liability and/or criminal prosecution.
              </li>
            </ol>

            <h2>19. Your Conduct and Safety</h2>
            <ol>
              <li>
                For your protection and protection of all our Customers, the
                posting of any content on the Service, as well as conduct in
                connection therewith and/or the Service, which is in any way
                unlawful, inappropriate or undesirable is strictly prohibited
                (“Prohibited Behaviour”).
              </li>
              <li>
                If you engage in Prohibited Behaviour, or we determine in our
                sole discretion that you are engaging in Prohibited Behaviour,
                your Account and/or your access to or use of the Service may be
                terminated immediately without notice to you. Legal action may
                be taken against you by another Customer, other third party,
                enforcement authorities and/or us with respect to you having
                engaged in Prohibited Behaviour.
              </li>
              <li>
                Prohibited Behaviour includes, but is not limited to, accessing
                or using the Service to: promote or share information that you
                know is false, misleading or unlawful; conduct any unlawful or
                illegal activity, such as, but not limited to, any activity that
                furthers or promotes any criminal activity or enterprise,
                violates another Customer's or any other third party’s privacy
                or other rights or that creates or spreads computer viruses;
                <ul>
                  <li>Harm minors in any way;</li>
                  <li>
                    Transmit or make available any content that is unlawful,
                    harmful, threatening, abusive, tortuous, defamatory, vulgar,
                    obscene, lewd, violent, hateful, or racially or ethnically
                    or otherwise objectionable;
                  </li>
                  <li>
                    Transmit or make available any content that the user does
                    not have a right to make available under any law or
                    contractual or fiduciary relationship, including without
                    limitation, any content that infringes a third party’s
                    copyright, trademark or other intellectual property and
                    proprietary rights;
                  </li>
                  <li>
                    Transmit or make available any content or material that
                    contains any software virus or other computer or programming
                    code (including HTML) designed to interrupt, destroy or
                    alter the functionality of the Service, its presentation or
                    any other website, computer software or hardware;
                  </li>
                  <li>
                    Interfere with, disrupt or reverse engineer the Service in
                    any manner, including, without limitation, intercepting,
                    emulating or redirecting the communication protocols used by
                    us, creating or using cheats, mods or hacks or any other
                    software designed to modify the Service, or using any
                    software that intercepts or collects information from or
                    through the Service; retrieve or index any information from
                    the Service using any robot, spider or other automated
                    mechanism;
                  </li>
                  <li>
                    Participate in any activity or action that, in the sole and
                    entire unfettered discretion of us results or may result in
                    another Customer being defrauded or scammed;
                  </li>
                  <li>
                    Transmit or make available any unsolicited or unauthorised
                    advertising or mass mailing such as, but not limited to,
                    junk mail, instant messaging, "spim", "spam", chain letters,
                    pyramid schemes or other forms of solicitations;
                  </li>
                  <li>
                    Create Accounts on the Website by automated means or under
                    false or fraudulent pretences;
                  </li>
                  <li>
                    Impersonate another Customer or any other third party, or
                    any other act or thing done that we reasonably consider to
                    be contrary to our business principles.
                  </li>
                </ul>
              </li>
            </ol>
            <p>
              The above list of Prohibited Behaviour is not exhaustive and may
              be modified by us at any time or from time to time. We reserve the
              right to investigate and to take all such actions as we in our
              sole discretion deem appropriate or necessary under the
              circumstances, including without limitation deleting the
              Customer’s posting(s) from the Service and/or terminating their
              Account, and take any action against any Customer or third party
              who directly or indirectly in, or knowingly permits any third
              party to directly or indirectly engage in Prohibited Behaviour,
              with or without notice to such Customer or third party.
            </p>

            <h2>20. Links to Other Websites</h2>
            <p>
              The Service may contain links to third party websites that are not
              maintained by, or related to, us, and over which we have no
              control. Links to such websites are provided solely as a
              convenience to Customers, and are in no way investigated,
              monitored or checked for accuracy or completeness by us. Links to
              such websites do not imply any endorsement by us of, and/or any
              affiliation with, the linked websites or their content or their
              owner(s). We have no control over or responsibility for the
              availability nor their accuracy, completeness, accessibility and
              usefulness. Accordingly when accessing such websites we recommend
              that you should take the usual precautions when visiting a new
              website including reviewing their privacy policy and terms of use.
            </p>

            <h2>21. Complaints</h2>
            <ol>
              <li>
                If you have any concerns or questions regarding these Terms you
                should contact our Customer Service Department via the links on
                the Website and use your Registered Email Address in all
                communication with us.
              </li>
              <li>
                NOTWITHSTANDING THE FOREGOING, WE TAKE NO LIABILITY WHATSOEVER
                TO YOU OR TO ANY THIRD PARTY WHEN RESPONDING TO ANY COMPLAINT
                THAT WE RECEIVED OR TOOK ACTION IN CONNECTION THEREWITH.
              </li>
              <li>
                If a Customer is not satisfied with how a bet has been settled
                then the Customer should provide details of their grievance to
                our Customer Service Department. We shall use our reasonable
                endeavours to respond to queries of this nature within a few
                days (and in any event we intend to respond to all such queries
                within 28 days of receipt).
              </li>
              <li>
                Disputes must be lodged within three (3) days from the date the
                wager in question has been decided. No claims will be honoured
                after this period. The Customer is solely responsible for their
                Account transactions.
              </li>
              <li>
                In the event of a dispute arising between you and us our
                Customer Service Department will attempt to reach an agreed
                solution. Should our Customer Service Department be unable to
                reach an agreed solution with you, the matter will be escalated
                to our management.
              </li>
              <li>
                Should all efforts to resolve a dispute to the Customer's
                satisfaction have failed, the Customer has the right to have the
                dispute settled via arbitration.
              </li>
            </ol>

            <h2>22. Assignment</h2>
            <p>
              Neither these Terms nor any of the rights or obligations hereunder
              may be assigned by you without the prior written consent of us,
              which consent will not be unreasonably withheld. We may, without
              your consent, assign all or any portion of our rights and
              obligations hereunder to any third party provided such third party
              is able to provide a service of substantially similar quality to
              the Service by posting written notice to this effect on the
              Service.
            </p>

            <h2>23. Severability</h2>
            <p>
              In the event that any provision of these Terms is deemed by any
              competent authority to be unenforceable or invalid, the relevant
              provision shall be modified to allow it to be enforced in line
              with the intention of the original text to the fullest extent
              permitted by applicable law. The validity and enforceability of
              the remaining provisions of these Terms shall not be affected.
            </p>

            <h2>24. Breach of These Terms</h2>
            <p>
              Without limiting our other remedies, we may suspend or terminate
              your Account and refuse to continue to provide you with the
              Service, in either case without giving you prior notice, if, in
              our reasonable opinion, you breach any material term of these
              Terms. Notice of any such action taken will, however, be promptly
              provided to you.
            </p>

            <h2>25. General Provisions</h2>
            <ol>
              <li>
                <strong>Term of agreement.</strong> These Terms shall remain in
                full force and effect while you access or use the Service or are
                a Customer or visitor of the Website. These Terms will survive
                the termination of your Account for any reason.
              </li>
              <li>
                <strong>Gender.</strong> Words importing the singular number
                shall include the plural and vice versa, words importing the
                masculine gender shall include the feminine and neuter genders
                and vice versa and words importing persons shall include
                individuals, partnerships, associations, trusts, unincorporated
                organisations and corporations.
              </li>
              <li>
                <strong>Waiver.</strong> No waiver by us, whether by conduct or
                otherwise, of a breach or threatened breach by you of any term
                or condition of these Terms shall be effective against, or
                binding upon, us unless made in writing and duly signed by us,
                and, unless otherwise provided in the written waiver, shall be
                limited to the specific breach waived. The failure of us to
                enforce at any time any term or condition of these Terms shall
                not be construed to be a waiver of such provision or of the
                right of us to enforce such provision at any other time.
              </li>
              <li>
                <strong>Acknowledgement.</strong> By hereafter accessing or
                using the Service, you acknowledge having read, understood and
                agreed to each and every paragraph of these Terms. As a result,
                you hereby irrevocably waive any future argument, claim, demand
                or proceeding to the contrary of anything contained in these
                Terms.
              </li>
              <li>
                <strong>Language.</strong> In the event of there being a
                discrepancy between the English language version of these rules
                and any other language version, the English language version
                will be deemed to be correct.
              </li>
              <li>
                <strong>Governing Law.</strong> These Terms are governed
                exclusively by the law in force in the state of Anjouan in the
                Union of Comoros.
              </li>
              <li>
                <strong>Entire agreement.</strong> These Terms constitute the
                entire agreement between you and us with respect to your access
                to and use of the Service, and supersedes all other prior
                agreements and communications, whether oral or written with
                respect to the subject matter hereof.
              </li>
            </ol>

            <p>
              <strong>
                PC Play365 reserves the right to change these terms and conditions
                at any time.
              </strong>
            </p>
          </div>
        </section>
      </div>
    </>
  );
}
